import { useI18nContext } from "@hopper-b2b/i18n";

interface WatchTripFailureProps {
  cn: (elementName: string) => string;
}

export const WatchTripFailure = ({
  cn,
}: WatchTripFailureProps): JSX.Element => {
  const { t } = useI18nContext();
  return (
    <div
      className={cn("failure-view")}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <p className={cn("subtitle")}>
        {t("flightShopPrediction.priceWatch.failureTitle")}
      </p>

      <p className={cn("description")}>
        {t("flightShopPrediction.priceWatch.failureMessage")}
      </p>
    </div>
  );
};
